"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.InnerInput = void 0;
var _reactI18next = require("react-i18next");
var _classnames5 = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reduxForm = require("redux-form");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _dataTestAttributeHelper = require("../../../helpers/dataTestAttributeHelper");
var _APButton = _interopRequireDefault(require("../APButton"));
require("./APInput.css");
var _excluded = ["input", "customClass", "classModifiers", "meta", "rows", "info", "label", "labelInInput", "rightLabelText", "iconComponent", "buttonInInput", "onButtonClick", "initialValue", "onBlur"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var baseClass = 'ap-input';
var InnerInput = exports.InnerInput = function InnerInput(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  var input = props.input,
    customClass = props.customClass,
    classModifiers = props.classModifiers,
    meta = props.meta,
    rows = props.rows,
    info = props.info,
    label = props.label,
    labelInInput = props.labelInInput,
    rightLabelText = props.rightLabelText,
    iconComponent = props.iconComponent,
    buttonInInput = props.buttonInInput,
    onButtonClick = props.onButtonClick,
    initialValue = props.initialValue,
    onBlur = props.onBlur,
    passedProps = _objectWithoutProperties(props, _excluded);
  var isTextArea = rows > 1;
  var bemClasses = (0, _cssClassesHelper.getBEMClasses)([baseClass, customClass]);
  var inputProps = _objectSpread(_objectSpread(_objectSpread({
    className: (0, _classnames5["default"])('form-control', _defineProperty({}, bemClasses('with-label'), labelInInput), _defineProperty({}, bemClasses('input', 'error', ''), meta && meta.dirty && meta.error), _defineProperty({}, bemClasses('text-area'), isTextArea), _defineProperty({}, bemClasses('button-in-input'), buttonInInput), rightLabelText ? bemClasses('input', 'with-right-label') : bemClasses('input', classModifiers))
  }, input), passedProps), {}, {
    onBlur: onBlur // Ensure onBlur is passed to handle blur correctly
  });

  // Ensure input and input.value are defined
  var inputValue = input ? input.value : '';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group ".concat(bemClasses('input-wrapper', classModifiers))
  }, props.type !== 'hidden' && /*#__PURE__*/_react["default"].createElement("label", {
    className: "ap--label ".concat(bemClasses('label', classModifiers))
  }, label), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames5["default"])(rightLabelText && bemClasses('input-with-right-label-container'), bemClasses('input-box'))
  }, labelInInput && /*#__PURE__*/_react["default"].createElement("span", {
    className: "label-in-input ".concat(bemClasses('label-in-input'))
  }, labelInInput), buttonInInput && /*#__PURE__*/_react["default"].createElement("span", {
    className: "button-in-input ".concat(bemClasses('label-in-input'))
  }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    onClick: onButtonClick
  }, t('Add'))), initialValue ? isTextArea ? /*#__PURE__*/_react["default"].createElement("textarea", _extends({}, inputProps, {
    "data-test": (0, _dataTestAttributeHelper.getDataTestAttribute)(props, 'label')
  }), initialValue) : !iconComponent ? /*#__PURE__*/_react["default"].createElement("input", _extends({
    "data-test": (0, _dataTestAttributeHelper.getDataTestAttribute)(props, 'label')
  }, inputProps, {
    value: initialValue
  })) : /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('input-with-icon')
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({
    "data-test": (0, _dataTestAttributeHelper.getDataTestAttribute)(props, 'label')
  }, inputProps, {
    value: initialValue
  })), iconComponent) : isTextArea ? /*#__PURE__*/_react["default"].createElement("textarea", _extends({}, inputProps, {
    "data-test": (0, _dataTestAttributeHelper.getDataTestAttribute)(props, 'label')
  })) : !iconComponent ? /*#__PURE__*/_react["default"].createElement("input", _extends({
    "data-test": (0, _dataTestAttributeHelper.getDataTestAttribute)(props, 'label')
  }, inputProps, {
    value: inputValue // Use inputValue with a default empty string
  })) : /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('input-with-icon')
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({
    "data-test": (0, _dataTestAttributeHelper.getDataTestAttribute)(props, 'label')
  }, inputProps, {
    value: inputValue // Use inputValue with a default empty string
  })), iconComponent), rightLabelText ? /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('right-label')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: bemClasses('right-label-span')
  }, rightLabelText)) : null, info && /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-text-muted ".concat(bemClasses('info'))
  }, info), meta && !meta.pristine && meta.error && /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('error')
  }, t(meta.error))));
};
var APInput = function APInput(props) {
  return /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, _extends({
    name: props.name,
    component: InnerInput
  }, props));
};
APInput.defaultProps = {
  name: '',
  label: '',
  labelInInput: '',
  type: '',
  classModifiers: '',
  placeholder: '',
  info: '',
  autoFocus: '',
  disabled: false,
  required: false,
  rows: 1,
  buttonInInput: false
};
APInput.propTypes = {
  name: _propTypes["default"].string,
  label: _propTypes["default"].string,
  labelInInput: _propTypes["default"].string,
  type: _propTypes["default"].string,
  customClass: _propTypes["default"].string,
  classModifiers: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  placeholder: _propTypes["default"].string,
  info: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  autoFocus: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  required: _propTypes["default"].bool,
  rightLabelText: _propTypes["default"].string,
  rows: _propTypes["default"].number,
  dataTest: _propTypes["default"].string,
  buttonInInput: _propTypes["default"].bool,
  onButtonClick: _propTypes["default"].func
};
var _default = exports["default"] = APInput;